<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <h1 class="fs-18 fs-md-20 fw-semibold mb-0">Fluxo de Entrada</h1>
      <!-- <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateUserModal"
        >
          Realizar lancamento
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div> -->
    </div>





    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Data
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Categoria
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Serviço
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Atendente
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Cliente
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Forma de pagamento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Taxa do pagamento
              </th>
            </tr>
          </thead>
          <tbody>




            <tr v-for="(value, key) in getFinancialData" :key="key">
              
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ formtattedDate(value.date, value.hour) }}
                  </div>
                </div>
              </th>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.category }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.service }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.attendant }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <a :href="`https://wa.me/55${value.client_phone}`" target="_blank" class="text-decoration-none">
                  {{ value.client_phone }} - {{ value.client_name != null ? value.client_name : 'Sem nome' }}
                </a>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.amount_received }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.payment_method }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.tax }}
              </td>



            </tr>
          
          
          
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getFinancialPagination.last_page || 1 }} —
          Total de {{ getFinancialPagination.total || (getFinancialData ? getFinancialData.length : 0) }} lançamentos
        </div>
        <nav aria-label="Paginação do fluxo de entrada">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getFinancialPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getFinancialPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>








  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "IncomingAmount",
  computed: {
    ...mapGetters([
      'getFinancialData',
      'getFinancialPagination',
      'getFinancialQuery'
    ]),
    currentPage(): number { return this.getFinancialPagination.current_page || 1; },
    
  },
  methods: {
    ...mapActions([
      "fetchFinancialData",
    ]),
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }
      await this.fetchFinancialData({
        month: this.getFinancialQuery?.month,
        year: this.getFinancialQuery?.year,
        page,
      });
    },
    goToPage(page) {
      if (page < 1 || (this.getFinancialPagination.last_page && page > this.getFinancialPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    },
    formtattedDate(date, hour) {
      return moment(date).format('DD/MM/YYYY') + ' ' + hour;
    }
  }
});
</script>
